import { configureStore } from "@reduxjs/toolkit";
import commonLocationReducer from "../redux/slices/CommonLocation";
import driverReducer from "../redux/slices/DriverSlice";
import fleetInfoReducer from "../redux/slices/FleetManager";
import personalInfoReducer from "../redux/slices/PersonalAccountInformationSlice";
import segmentEventsReducer from "../redux/slices/SegmentEvents";
import vehicleReducer from "../redux/slices/VehicleSlice";

export const store = configureStore({
  reducer: {
    personalInfo: personalInfoReducer,
    fleetManager: fleetInfoReducer,
    commonLocation: commonLocationReducer,
    vehicle: vehicleReducer,
    driver: driverReducer,
    segmentEvents: segmentEventsReducer,
  },
});
